import React from "react";
import styled from "styled-components";
import { useTheme } from "@mui/material/styles";


function TermCondition() {
  const theme = useTheme();
  const TermConditionContent = styled.div`
  .section {
    margin-bottom: 40px;
    
    @media (max-width: 768px) {
      margin-bottom: 30px;
    }
  }
  
  .section-title {
    color: #2c3e50;
    font-size: 1.4rem;
    font-weight: 600;
    margin-bottom: 15px;
    padding-bottom: 8px;
    border-bottom: 2px solid ${theme.palette.header.main};
    
    @media (max-width: 768px) {
      font-size: 1.2rem;
      margin-bottom: 12px;
    }
  }
  
  .subsection {
    margin-bottom: 25px;
    
    @media (max-width: 768px) {
      margin-bottom: 20px;
    }
  }
  
  .subsection-title {
    color: #34495e;
    font-size: 1.1rem;
    font-weight: 600;
    margin-bottom: 10px;
    
    @media (max-width: 768px) {
      font-size: 1rem;
      margin-bottom: 8px;
    }
  }
  
  .content-text {
    color: #555;
    line-height: 1.6;
    margin-bottom: 12px;
    
    @media (max-width: 768px) {
      line-height: 1.5;
      margin-bottom: 10px;
    }
  }
  
  .highlight-box {
    background: #f8f9fa;
    border-left: 4px solid #3498db;
    padding: 15px 20px;
    margin: 20px 0;
    border-radius: 0 8px 8px 0;
    
    @media (max-width: 768px) {
      padding: 12px 15px;
      margin: 15px 0;
    }
  }
  
  .highlight-text {
    color: #2c3e50;
    font-weight: 500;
    margin: 0;
  }
  
  .list-item {
    margin-bottom: 8px;
    padding-left: 5px;
    
    @media (max-width: 768px) {
      margin-bottom: 6px;
    }
  }
  
  .contact-info {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    padding: 20px;
    border-radius: 10px;
    margin: 30px 0;
    
    @media (max-width: 768px) {
      padding: 15px;
      margin: 20px 0;
    }
  }
  
  .contact-title {
    font-weight: 600;
    margin-bottom: 10px;
    font-size: 1.1rem;
  }
  
  .contact-text {
    margin: 5px 0;
    opacity: 0.9;
  }
`;

  return (
    <TermConditionContent>
      <div className="section">
        <h2 className="section-title">Terms & Conditions</h2>
        <p className="content-text">
          Please read these Terms & Conditions carefully before accessing or
          using our website. By accessing or using pawprintID® (or permitting
          others to access or use pawprintID®), you acknowledge your
          understanding and agreement with these Terms & Conditions. This
          agreement supersedes ANY prior agreement or understanding between you
          and pawprintID®. We may modify these Terms & Conditions from time to
          time, and such modifications will be effective immediately upon
          posting of the modified Terms & Conditions on our website. By
          continuing to access or use the website, you acknowledge your
          understanding and agreement with the modified Terms & Conditions.
          Therefore, it is your obligation to access and review the Terms &
          Conditions frequently.
        </p>
      </div>
    </TermConditionContent>
  );
}

export default TermCondition;
